// Copyright (c) 2021 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function auditof87BatchSubstitution ( file ) {

    const endPoint = `${basePath}/audit-of87batch`;

    const formData = new FormData();

    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function uploadof87BatchSubstitution ( file ) {

    const endPoint = `${basePath}/upload-of87batch`;
    const formData = new FormData();

    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST'
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
